module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row input-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n      Search on YouTube:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.handleSearchInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box found-videos"
  }, [(_vm.searchLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.foundVideos.length === 0) ? _c('span', [_vm._v("No videos found.")]) : _c('ul', _vm._l((_vm.foundVideos), function(foundVideo) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.selectVideo(foundVideo.id.videoId)
        }
      }
    }, [_c('div', {
      staticClass: "video-item"
    }, [_c('div', {
      staticClass: "video-image"
    }, [_c('img', {
      attrs: {
        "src": foundVideo.snippet.thumbnails.default.url,
        "alt": foundVideo.snippet.title,
        "width": foundVideo.snippet.thumbnails.default.width,
        "height": foundVideo.snippet.thumbnails.default.height
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "video-padder"
    }), _vm._v(" "), _c('div', {
      staticClass: "video-description"
    }, [_vm._v("\n              " + _vm._s(foundVideo.snippet.title) + "\n            ")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n      Enter YouTube video id or url here:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video),
      expression: "video"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.video)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.video && _vm.video.length > 0) ? _c('player', {
    ref: "player",
    attrs: {
      "id": _vm.video,
      "start": parseInt(_vm.start, 10),
      "end": parseInt(_vm.end, 10)
    },
    on: {
      "playing": _vm.handleVideo,
      "ready": _vm.handleVideo
    }
  }) : _c('span', [_vm._v("\n        Select a video.\n      ")]), _vm._v(" "), (_vm.end > 0) ? _c('vue-slider', {
    ref: "slider",
    staticClass: "slider",
    attrs: {
      "value": _vm.sliderValues,
      "tooltip": "always",
      "formatter": function (x) {
        return _vm.toHHMMSS(x)
      },
      "min": _vm.min,
      "max": _vm.max,
      "tooltipDir": ['top', 'bottom'],
      "dot-size": 10
    },
    on: {
      "drag-end": _vm.handleDragEnd
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "box"
  }, [(!_vm.recording) ? _c('button', {
    on: {
      "click": _vm.handleStartRecord
    }
  }, [_vm._v("\n        Record\n      ")]) : _c('button', {
    on: {
      "click": _vm.handleStopRecord
    }
  }, [_vm._v("\n        Stop recording\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 center-xs"
  }, [_c('div', {
    staticClass: "next-button-container"
  }, [(_vm.valid) ? _c('a', {
    staticClass: "disabled-button"
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v("\n        Enter the required fields\n      ")]) : _c('a', {
    staticClass: "default-button",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addEntry($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-checkmark"
  }), _vm._v("\n        Create entry\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n      Select your video\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa06ab5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/Add/Content/index.vue
// module id = 708
// module chunks = 1